import React from 'react';
import './App.css';

// Pages
import Home from './pages/Home';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <main>
        <Home />
      </main>
    </div>
  );
}

export default App;